// import React from "react";

// function MaterialCard({ material, onView }) {
//   return (
//     <div
//       style={{
//         background: "#fff",
//         borderRadius: "10px",
//         padding: "20px",
//         boxShadow: "0 2px 10px rgba(0,0,0,.1)",
//       }}
//     >
//       <h3>{material.title}</h3>

//       <p>{material.description}</p>

//       <p>
//         <strong>Type:</strong> {material.type.toUpperCase()}
//       </p>

//       <button
//         onClick={() => onView(material)}
//         style={{
//           background: "#2563eb",
//           color: "#fff",
//           border: "none",
//           padding: "10px 18px",
//           borderRadius: "6px",
//           cursor: "pointer",
//         }}
//       >
//         {material.type === "video"
//           ? "Watch Video"
//           : "View Material"}
//       </button>
//     </div>
//   );
// }

// export default MaterialCard;
import React from "react";

function MaterialCard({ material, onView }) {
  const getIcon = () => {
    switch (material.type) {
      case "pdf":
        return "📕";
      case "video":
        return "🎥";
      case "doc":
        return "📄";
      default:
        return "📁";
    }
  };

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: "12px",
        padding: "20px",
        boxShadow: "0 5px 15px rgba(0,0,0,.08)",
        transition: ".3s",
      }}
    >
      <div style={{ fontSize: "45px", textAlign: "center" }}>
        {getIcon()}
      </div>

      <h3
        style={{
          textAlign: "center",
          marginTop: "10px",
          color: "#1f2937",
        }}
      >
        {material.title}
      </h3>

      <p
        style={{
          color: "#666",
          textAlign: "center",
          minHeight: "45px",
        }}
      >
        {material.description}
      </p>

      <p
        style={{
          textAlign: "center",
          fontWeight: "bold",
        }}
      >
        {material.type.toUpperCase()}
      </p>

      <button
        onClick={() => onView(material)}
        style={{
          width: "100%",
          padding: "12px",
          background: "#2563eb",
          color: "#fff",
          border: "none",
          borderRadius: "8px",
          cursor: "pointer",
          fontWeight: "bold",
          fontSize: "15px",
        }}
      >
        {material.type === "video"
          ? "▶ Watch Video"
          : "📖 Open Material"}
      </button>
    </div>
  );
}

export default MaterialCard;